import React from "react";
import styled from "styled-components";

const UsernameEditModal = ({ isOpen, onClose, username, onChange, onSave }) => {
  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalBody>
        <CloseBtn onClick={onClose}>✕</CloseBtn>
        <Title>EDITAR USUARIO</Title>
        <Input
          placeholder="Nombre de usuario"
          value={username}
          onChange={onChange}
          autoFocus
        />
        <SaveBtn onClick={onSave}>GUARDAR</SaveBtn>
      </ModalBody>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
`;

const ModalBody = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  position: relative;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: var(--v-fg-muted);
  font-size: 16px;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

const Title = styled.h3`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-fg-muted);
  margin: 0 0 1.5rem;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  color: var(--v-fg);
  font-family: var(--v-font-body);
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s ease;
  box-sizing: border-box;

  &:focus {
    border-color: var(--v-mint);
  }

  &::placeholder {
    color: var(--v-fg-muted);
    opacity: 0.4;
  }
`;

const SaveBtn = styled.button`
  display: block;
  margin: 1.25rem auto 0;
  background: var(--v-mint);
  border: none;
  color: #000;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.6rem 2rem;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export default UsernameEditModal;
